import { render, staticRenderFns } from "./ExamForm.vue?vue&type=template&id=52f4288c&scoped=true"
import script from "./ExamForm.vue?vue&type=script&lang=js"
export * from "./ExamForm.vue?vue&type=script&lang=js"
import style0 from "./ExamForm.vue?vue&type=style&index=0&id=52f4288c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4288c",
  null
  
)

export default component.exports